import type { SVGProps } from "react";

export default function PowerPointIcon(
  props: Readonly<SVGProps<SVGSVGElement>>,
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <path
        d="M11.8313 10.8125L10.6107 1.875H10.5195C8.3885 1.87862 6.34564 2.72572 4.83742 4.23113C3.3292 5.73653 2.4783 7.77781 2.4707 9.90875V10L11.8313 10.8125Z"
        fill="#ED6C47"
      />
      <path
        d="M10.7021 1.875H10.6108V10L14.6802 11.625L18.7502 10V9.90875C18.7426 7.77792 17.8918 5.73673 16.3837 4.23135C14.8756 2.72596 12.8329 1.87879 10.7021 1.875Z"
        fill="#FF8F6B"
      />
      <path
        d="M18.7501 10V10.0894C18.7422 12.2206 17.891 14.2621 16.3827 15.7677C14.8743 17.2734 12.8313 18.1209 10.7001 18.125H10.5207C8.38956 18.1206 6.34677 17.273 4.83848 15.7674C3.33018 14.2618 2.47895 12.2205 2.4707 10.0894V10H18.7501Z"
        fill="#D35230"
      />
      <path
        opacity="0.1"
        d="M11.0176 5.86813V14.5375C11.0165 14.685 10.9719 14.8289 10.8894 14.9512C10.8069 15.0735 10.6902 15.1687 10.5538 15.225C10.4648 15.2625 10.3692 15.2818 10.2726 15.2819H4.39196C4.27821 15.1519 4.16821 15.0138 4.06633 14.8756C3.02964 13.4956 2.46962 11.816 2.47071 10.09V9.91125C2.46874 8.35433 2.92451 6.83119 3.78133 5.53125C3.87071 5.39313 3.96446 5.255 4.06633 5.125H10.2726C10.4694 5.1263 10.6579 5.20496 10.7973 5.34399C10.9367 5.48301 11.0158 5.67127 11.0176 5.86813Z"
        fill="black"
      />
      <path
        opacity="0.2"
        d="M10.6107 6.275V14.9444C10.6107 15.0406 10.5913 15.1358 10.5538 15.2244C10.4974 15.3606 10.4022 15.4772 10.2799 15.5595C10.1576 15.6419 10.0138 15.6864 9.86633 15.6875H4.76258C4.63383 15.5567 4.51029 15.4213 4.39196 15.2812C4.27821 15.1512 4.16821 15.0131 4.06633 14.875C3.02964 13.495 2.46962 11.8154 2.47071 10.0894V9.91062C2.46887 8.35392 2.92463 6.83101 3.78133 5.53125H9.86571C10.0627 5.53256 10.2512 5.6113 10.3906 5.75046C10.53 5.88962 10.6091 6.07804 10.6107 6.275Z"
        fill="black"
      />
      <path
        opacity="0.2"
        d="M10.6107 6.275V14.1319C10.6089 14.3287 10.5298 14.517 10.3904 14.656C10.251 14.795 10.0626 14.8737 9.86571 14.875H4.06633C3.02964 13.495 2.46962 11.8154 2.47071 10.0894V9.91062C2.46887 8.35392 2.92463 6.83101 3.78133 5.53125H9.86571C10.0627 5.53256 10.2512 5.6113 10.3906 5.75046C10.53 5.88962 10.6091 6.07804 10.6107 6.275Z"
        fill="black"
      />
      <path
        opacity="0.2"
        d="M10.2038 6.275V14.1319C10.202 14.3287 10.1229 14.517 9.98353 14.656C9.84415 14.795 9.65569 14.8737 9.45883 14.875H4.06633C3.02964 13.495 2.46962 11.8154 2.47071 10.0894V9.91062C2.46887 8.35392 2.92463 6.83101 3.78133 5.53125H9.45883C9.6558 5.53256 9.84435 5.6113 9.98374 5.75046C10.1231 5.88962 10.2022 6.07804 10.2038 6.275Z"
        fill="black"
      />
      <path
        d="M1.99625 5.53125H9.4575C9.65514 5.53109 9.84477 5.6094 9.9847 5.74898C10.1246 5.88856 10.2034 6.07798 10.2038 6.27563V13.7244C10.2034 13.922 10.1246 14.1114 9.9847 14.251C9.84477 14.3906 9.65514 14.4689 9.4575 14.4688H1.99625C1.89836 14.4689 1.8014 14.4498 1.71091 14.4125C1.62042 14.3751 1.53817 14.3203 1.46887 14.2512C1.39956 14.1821 1.34456 14.1 1.30701 14.0096C1.26945 13.9192 1.25008 13.8223 1.25 13.7244V6.27563C1.25008 6.17774 1.26945 6.08083 1.30701 5.99043C1.34456 5.90003 1.39956 5.81792 1.46887 5.74879C1.53817 5.67966 1.62042 5.62487 1.71091 5.58754C1.8014 5.55021 1.89836 5.53109 1.99625 5.53125Z"
        fill="url(#paint0_linear_5937_191169)"
      />
      <path
        d="M5.80789 7.51757C6.2936 7.4849 6.77513 7.62577 7.16664 7.91507C7.32762 8.05838 7.45384 8.23647 7.53571 8.43584C7.61758 8.63521 7.65295 8.85062 7.63914 9.0657C7.6446 9.36868 7.56375 9.66696 7.40602 9.9257C7.24643 10.1803 7.01656 10.3833 6.74414 10.5101C6.43289 10.6544 6.09279 10.7258 5.74977 10.7188H4.80414V12.4688H3.83789V7.51757H5.80789ZM4.80352 9.96257H5.63539C5.89915 9.98159 6.16076 9.90357 6.37102 9.7432C6.45699 9.66119 6.52394 9.56133 6.56713 9.45064C6.61033 9.33995 6.62872 9.22114 6.62102 9.10257C6.62102 8.55716 6.30331 8.28424 5.66789 8.28382H4.80352V9.96257Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_5937_191169"
          x1="2.80875"
          y1="4.94625"
          x2="8.645"
          y2="15.0538"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CA4C28" />
          <stop offset="0.5" stopColor="#C5401E" />
          <stop offset="1" stopColor="#B62F14" />
        </linearGradient>
      </defs>
    </svg>
  );
}
